import { Toaster } from 'sonner';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { recordVisit } from '@/lib/recent';
import { WhatsNewAutoPrompt } from '@/components/common/WhatsNew';
import { FeedbackButton } from '@/components/common/FeedbackButton';
import { TourOverlay } from '@/components/tour/TourOverlay';

export const AppShell = ({ children, breadcrumbs = [], right = null }) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const label = breadcrumbs.length ? breadcrumbs.map(b => b.label).join(' / ') : location.pathname;
    recordVisit(location.pathname, label);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);
  return (
    <div className="min-h-screen flex" style={{ background: 'hsl(var(--background))' }}>
      <Sidebar mobileOpen={mobileOpen} onCloseMobile={() => setMobileOpen(false)} />
      <div className="flex-1 flex flex-col min-w-0">
        <Topbar breadcrumbs={breadcrumbs} onOpenMobileSidebar={() => setMobileOpen(true)} />
        <main className="flex-1 min-w-0" data-testid="app-main">
          {children}
        </main>
      </div>
      <WhatsNewAutoPrompt />
      <TourOverlay />
      <FeedbackButton />
      <Toaster richColors position="top-right" />
    </div>
  );
};
